export default {
  // ===== 页面标题(订单批/运营批两页各自,其余键两页共用) =====
  'pages.log.orderBatch.title': '订单批处理日志',
  'pages.log.orderBatch.subtitle':
    'A-POS 订单上行同步批次(ppos_sync_batch)的处理记录:查看原始请求数据、错误信息与失败明细,按时间、是否有错误、是否被消费等筛选',
  'pages.log.operationalBatch.title': '运营批处理日志',
  'pages.log.operationalBatch.subtitle':
    '运营数据上行同步批次(ppos_operational_sync_batch)的处理记录:查看原始请求数据、错误信息与失败明细,按时间、是否有错误、是否被消费等筛选',

  // ===== 表格列 =====
  'pages.log.syncBatch.column.receiveTime': '接收时间',
  'pages.log.syncBatch.column.receiveTimeRange': '接收时间区间',
  'pages.log.syncBatch.column.batchNo': '批次号',
  'pages.log.syncBatch.column.batchNo.placeholder': '精确匹配',
  'pages.log.syncBatch.column.batchNo.copy': '复制批次号',
  'pages.log.syncBatch.column.batchNo.copied': '已复制',
  'pages.log.syncBatch.column.tenant': '租户',
  'pages.log.syncBatch.column.tenant.placeholder': '请选择租户(可搜索)',
  'pages.log.syncBatch.column.store': '门店',
  'pages.log.syncBatch.column.store.placeholder': '请选择门店(可搜索)',
  'pages.log.syncBatch.column.store.placeholderFirst': '请先选择租户',
  'pages.log.syncBatch.column.posId': '设备ID',
  'pages.log.syncBatch.column.posId.copy': '复制设备ID',
  'pages.log.syncBatch.column.posId.copied': '已复制',
  'pages.log.syncBatch.column.counts': '总数 / 成功 / 失败 / 未覆盖',
  'pages.log.syncBatch.column.status': '批次结局',
  'pages.log.syncBatch.column.processStatus': '处理状态',
  'pages.log.syncBatch.column.consumed': '是否被消费',
  'pages.log.syncBatch.column.hasError': '是否有错误',
  'pages.log.syncBatch.column.errorMsg': '错误信息',
  'pages.log.syncBatch.column.retryCount': '重试次数',
  'pages.log.syncBatch.column.action': '操作',

  // ===== 载荷模式(2026-10-15 整单上传批 additive;仅订单批渲染) =====
  'pages.log.syncBatch.column.payloadMode': '载荷模式',
  'pages.log.syncBatch.payloadMode.wholeOrder': '整单',
  'pages.log.syncBatch.payloadMode.incremental': '增量',

  // ===== 枚举文案 =====
  'pages.log.syncBatch.processStatus.pending': '待处理',
  'pages.log.syncBatch.processStatus.processing': '处理中',
  'pages.log.syncBatch.processStatus.done': '完成',
  'pages.log.syncBatch.processStatus.failed': '失败',
  'pages.log.syncBatch.consumed.yes': '已消费',
  'pages.log.syncBatch.consumed.no': '未消费',
  'pages.log.syncBatch.hasError.yes': '有错误',
  'pages.log.syncBatch.hasError.no': '无错误',

  // ===== 通用占位/提示 =====
  'pages.log.syncBatch.placeholder.select': '请选择',
  'pages.log.syncBatch.tooltip.counts':
    '总记录数 / 成功数 / 失败数 / 未覆盖数(服务端未计入成败,含缺关联ID被拒记录)',
  'pages.log.syncBatch.tooltip.nameNotBackfilled': '名称未回填',
  // 设备名映射未命中时的回退标注(DISPLAY-F7,诊断例外显式声明)
  'pages.log.syncBatch.tooltip.posNameMiss':
    '设备名未命中:设备未注册或已删除,回退显示设备ID',
  // 计数第四 Tag『待处理 N』(=total-success-fail 差额,DISPLAY-F1)
  'pages.log.syncBatch.counts.uncovered': '待处理',
  // 批次结局×处理状态口径图例(DISPLAY-F2:HTTP 已受理≠处理终态)
  'pages.log.syncBatch.tooltip.statusLegend':
    'HTTP 已受理≠处理终态:接收成功仅代表报文已被受理;「处理状态」为 Phase2 异步处理进度,最终成败以「批次结局」为准,两者存在时差',

  // ===== 操作与消息 =====
  'pages.log.syncBatch.action.detail': '详情',
  // 处置闭环(DISPLAY-F6):携 batchNo 跳转上传报文页预填
  'pages.log.syncBatch.action.goReload': '去重载',
  'pages.log.syncBatch.action.goReload.tip':
    '跳转上传报文页并按本批次号预填,可对该批执行重载',
  'pages.log.syncBatch.msg.loadDetailFailed': '加载详情失败',
  'pages.log.syncBatch.msg.downloadFailed': '下载失败',

  // ===== 详情抽屉 =====
  'pages.log.syncBatch.drawer.title': '批次详情',
  'pages.log.syncBatch.drawer.loading': '加载中…',
  'pages.log.syncBatch.drawer.downloadRawRequest': '下载原始请求',
  'pages.log.syncBatch.detail.processStartTime': '处理开始时间',
  'pages.log.syncBatch.detail.processEndTime': '处理结束时间',
  'pages.log.syncBatch.detail.nextRetryTime': '下次重试时间',
  'pages.log.syncBatch.detail.processProgress': '处理进度',
  'pages.log.syncBatch.detail.rawRequestSize': '原始请求大小',
  'pages.log.syncBatch.detail.updateTime': '更新时间',
  'pages.log.syncBatch.detail.errorMsg': '错误信息',
  // 批次结局与处理状态组合展示项(DISPLAY-F2)
  'pages.log.syncBatch.detail.statusCombined': '批次结局 / 处理状态',
  'pages.log.syncBatch.detail.failDetail': '失败明细',
  // 失败阶段口径标注:明细产生于服务端异步落库阶段(DISPLAY-F3)
  'pages.log.syncBatch.detail.failDetailHint':
    '失败发生于服务端异步落库阶段(Phase2);HTTP 已受理不代表处理终态',
  'pages.log.syncBatch.detail.tableStats': '按表统计',
  'pages.log.syncBatch.detail.rawRequest': '原始请求数据',
  'pages.log.syncBatch.detail.truncatedTag': '已截断',
  'pages.log.syncBatch.detail.copyOriginal': '复制原始请求全文',
  'pages.log.syncBatch.detail.copyTruncated': '复制预览段(全文请下载)',
  'pages.log.syncBatch.detail.copied': '已复制',
  'pages.log.syncBatch.detail.noPreview': '无原始请求数据',

  // ===== 失败明细表格(DISPLAY-F3) =====
  'pages.log.syncBatch.failDetail.dataType': '数据类型',
  'pages.log.syncBatch.failDetail.businessNo': '业务单号',
  // 显式声明的诊断例外:POS 本地记录ID 供与端侧日志比对,非业务单号
  'pages.log.syncBatch.failDetail.recordId': 'POS 本地记录ID',
  'pages.log.syncBatch.failDetail.recordId.tip':
    'POS 本地记录ID(诊断用):客户端本地行主键,用于与端侧日志比对定位问题,非面向用户的业务单号',
  'pages.log.syncBatch.failDetail.errorMsg': '失败原因',

  // ===== failDetail.dataType 双映射(13 个英文常量 + 历史数字码 '13') =====
  'pages.log.syncBatch.dataType.SALES_ORDER': '销售订单',
  'pages.log.syncBatch.dataType.SALES_ORDER_ITEM': '销售订单明细',
  'pages.log.syncBatch.dataType.SALES_ORDER_PAYMENT': '销售订单支付',
  'pages.log.syncBatch.dataType.SALES_ORDER_DISCOUNT': '销售订单折扣分摊',
  'pages.log.syncBatch.dataType.SALES_ORDER_GOV_PERSON': '销售订单政府折扣人',
  'pages.log.syncBatch.dataType.SALES_ORDER_GOV_PERSON_ITEM_REL':
    '政府折扣人-商品关联',
  'pages.log.syncBatch.dataType.SALES_ORDER_PAYMENT_ALLOCATION':
    '销售订单支付分摊',
  'pages.log.syncBatch.dataType.SALES_ORDER_REFUND': '销售订单退款单',
  'pages.log.syncBatch.dataType.SALES_ORDER_REFUND_ITEM': '退款单明细',
  'pages.log.syncBatch.dataType.REFUND_GOV_PERSON_ITEM_REL':
    '退款政府折扣人-商品关联',
  'pages.log.syncBatch.dataType.SALES_ORDER_VOID': '销售订单作废单',
  'pages.log.syncBatch.dataType.DINING_ORDER': '餐饮订单',
  'pages.log.syncBatch.dataType.DINING_ORDER_ITEM': '餐饮订单明细',
  // 历史数字码(存量行,e2e 夹具形态;工作包口径 '13'→销售明细)
  'pages.log.syncBatch.dataType.13': '销售明细',

  // ===== 上传报文详情抽屉·批次处理结局(CLOUD-F3) =====
  'pages.log.syncBatch.detail.outcomeTitle': '批次处理结局',
  // 该批次号在同步批表无处理行(如报文在收包层即被拒收)
  'pages.log.syncBatch.detail.outcomeMissing':
    '未在同步批处理日志中找到该批次号的处理行',
  'pages.log.syncBatch.detail.outcomeError': '批次处理结局查询失败',
  // 计数三连标签(与批次日志页计数列同口径)
  'pages.log.syncBatch.counts.total': '总数',
  'pages.log.syncBatch.counts.success': '成功',
  'pages.log.syncBatch.counts.fail': '失败',
};
